class ZonvoHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.zv-hero__slide'));
    this.dots = Array.from(this.querySelectorAll('.zv-hero__dot'));
    this.current = 0;
    this.speed = (parseInt(this.dataset.autoplay, 10) || 5) * 1000;

    if (this.slides.length < 2) return;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goTo(index);
        this.restart();
      });
    });

    this.start();
  }

  goTo(index) {
    this.slides[this.current].classList.remove('is-active');
    this.dots[this.current] && this.dots[this.current].classList.remove('is-active');
    this.current = index;
    this.slides[this.current].classList.add('is-active');
    this.dots[this.current] && this.dots[this.current].classList.add('is-active');
  }

  next() {
    this.goTo((this.current + 1) % this.slides.length);
  }

  start() {
    this.timer = setInterval(() => this.next(), this.speed);
  }

  restart() {
    clearInterval(this.timer);
    this.start();
  }
}

customElements.define('zonvo-hero', ZonvoHero);
